.planName {
  font-weight: var(--weight-medium);
}

.muted {
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/* ------------------------------------------------------------------ form */
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

/* Two columns on a desktop admin screen, one on anything narrow — a numeric
   field squeezed to a few characters is worse than a stacked form. */
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

@media (max-width: 640px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.divider {
  height: 1px;
  background: var(--border);
  margin: var(--space-5) 0 var(--space-4);
}

.sectionTitle {
  margin: 0;
  font-size: var(--text-sm);
  font-weight: var(--weight-semibold);
}

.sectionHint {
  margin: 2px 0 var(--space-4);
  font-size: var(--text-xs);
  color: var(--text-muted);
}

/* *** THE ACTIONS MUST NOT SCROLL AWAY ***
   This form is long enough to scroll on a laptop, and a submit button below
   the fold on a create form reads as a broken screen. */
.formActions {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  padding-top: var(--space-4);
  margin-top: var(--space-5);
  background: var(--bg);
  border-top: 1px solid var(--border);
}
